import { BCOR } from '../../config/constants/action-types';
import { getLeadingProducts } from '../../helpers/leadingProducts';

export const errorBcor = (error) => (dispatch) => {
  return dispatch({ error, type: BCOR.ERROR_BCOR });
};

export const resetBcor = () => (dispatch) => {
  return dispatch({ type: BCOR.RESET_BCOR });
};

export const setCurrentDealId = (currentDealId) => (dispatch) => {
  return dispatch({ currentDealId, type: BCOR.SET_CURRENT_DEAL_ID });
};

export const setFilteredProducts = (filteredProducts) => (dispatch) => {
  return dispatch({ filteredProducts, type: BCOR.SET_FILTERED_PRODUCTS });
};

export const setNightOptions = (nightOptions) => (dispatch) => {
  return dispatch({ nightOptions, type: BCOR.SET_NIGHT_OPTIONS });
};

export const setProducts = (products) => (dispatch) => {
  return dispatch({ products, type: BCOR.SET_PRODUCTS });
};

export const setQuantity = (quantity) => (dispatch) => {
  return dispatch({ quantity, type: BCOR.SET_QUANTITY });
};

export const setSelectedNights = (selectedNights) => (dispatch) => {
  return dispatch({ selectedNights, type: BCOR.SET_SELECTED_NIGHTS });
};

export const setSelection = (selection) => (dispatch) => {
  return dispatch({ selection, type: BCOR.SET_SELECTION });
};

export const fetchLeadingProducts = (deal, currentDealId) => async (
  dispatch,
) => {
  if (currentDealId === deal.id) return false;
  dispatch(setCurrentDealId(deal.id));
  // default quantity
  dispatch(setQuantity(deal.pricePerPerson ? 2 : 1));
  try {
    const response = await getLeadingProducts(deal.id);
    const newLeadInPriceProducts = response?.leadInPriceProducts;
    const newNightOptions = response?.nightOptions;
    dispatch(setProducts(newLeadInPriceProducts));
    dispatch(setFilteredProducts(newLeadInPriceProducts));
    if (newNightOptions) {
      dispatch(setNightOptions(newNightOptions));
      // select first night option as default
      dispatch(setSelectedNights(newNightOptions[0].numberOfNights));
    }
    // select first product first tier(default tier) as default
    console.log('set selection after api call');
    dispatch(setSelection(newLeadInPriceProducts[0].tiers[0]));
  } catch {
    dispatch(errorBcor(true));
  }
};
